import {useEffect, useRef} from 'react';

interface IProps {
  map: naver.maps.Map;
}

export const CadastralLayer = ({map}: IProps) => {
  const ref = useRef<naver.maps.CadastralLayer>();

  useEffect(() => {
    if (map) {
      const layer = new naver.maps.CadastralLayer();

      layer.setMap(map);
      ref.current = layer;
    }

    return () => {
      if (ref.current) {
        ref.current.setMap(null);
      }
    };
  }, [map]);

  return null;
};
